module.exports = __webpack_public_path__ + "img/Ello-3.b716fc6e.png";